import type { ProviderHealth, ProviderOverview, ProviderStatus } from '@rp/contracts'
import { Chip, LedgerRow, type ChipTone } from '../../design'
import { formatDateTime } from '../../lib/time'
import { OPERATIONS_COPY, PROVIDER_HEALTH_COPY, PROVIDER_ROLE_COPY } from './copy'
import { providerStatusLine } from './providerStatusLine'

const HEALTH_TONES: Record<ProviderHealth, ChipTone> = {
  healthy: 'success',
  failing: 'warning',
  circuit_open: 'danger',
  recovering: 'warning',
}

const at = (instant: string): string => formatDateTime(new Date(instant))

const ProviderRow = ({ status }: { status: ProviderStatus }) => (
  <LedgerRow>
    <div className="ops-row">
      <span className="ops-row-title">{status.provider}</span>
      <Chip tone="neutral" variant="outline">
        {PROVIDER_ROLE_COPY[status.role]}
      </Chip>
      <Chip tone={HEALTH_TONES[status.health]} variant={status.health === 'circuit_open' ? 'solid' : 'wash'}>
        {PROVIDER_HEALTH_COPY[status.health]}
      </Chip>
      {status.health === 'healthy' || status.lastFailureAt === null ? null : (
        <span className="ops-row-note">{OPERATIONS_COPY.lastFailure(at(status.lastFailureAt), status.failureCount)}</span>
      )}
      {status.probeAfter === null || status.health !== 'circuit_open' ? null : (
        <span className="ops-row-note">{OPERATIONS_COPY.probeAfter(at(status.probeAfter))}</span>
      )}
    </div>
  </LedgerRow>
)

export const ProviderPanel = ({ overview }: { overview: ProviderOverview }) => {
  const line = providerStatusLine(overview)
  return (
    <section className="ops-section" aria-labelledby="ops-provider-title">
      <div className="ops-section-head">
        <h2 id="ops-provider-title">{OPERATIONS_COPY.providerTitle}</h2>
        <p className={`ops-section-summary${line.danger ? ' tone-danger' : ''}`} role="status">
          {line.text}
        </p>
      </div>
      <ul className="ledger-list ops-list" aria-label={OPERATIONS_COPY.providerTitle}>
        {overview.providers.map((status) => (
          <ProviderRow key={status.provider} status={status} />
        ))}
      </ul>
    </section>
  )
}
